<template>
 <router-view></router-view>
</template>

<script>
 export default {
  name: 'App',
   
  mounted() {
    document.documentElement.classList.add('dark');
  },
}

</script>

<style>

</style>
